
import { application } from "./application"

import ScrollRevealController from "./scroll_reveal_controller"
application.register("scroll-reveal", ScrollRevealController)

import DoctorSelectController from "./doctor_select_controller"
application.register("doctor-select", DoctorSelectController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import AbhaRegistrationController from "./abha_registration_controller"
application.register("abha-registration", AbhaRegistrationController)

import ShowMoreController from "./show_more_controller"
application.register("show-more", ShowMoreController)

import DoctorSlotsController from "./doctor_slots_controller"
application.register("doctor-slots", DoctorSlotsController)

import BookCtaController from "./book_cta_controller"
application.register("book-cta", BookCtaController)

import AutocompleteSearchController from "./autocomplete_search_controller"
application.register("autocomplete-search", AutocompleteSearchController)

import LocationPickerController from "./location_picker_controller"
application.register("location-picker", LocationPickerController)

import NavSearchController from "./nav_search_controller"
application.register("nav-search", NavSearchController)

import NearMeController from "./near_me_controller"
application.register("near-me", NearMeController)

import MapController from "./map_controller"
application.register("map", MapController)

import SearchMapController from "./search_map_controller"
application.register("search-map", SearchMapController)

import CardActionsController from "./card_actions_controller"
application.register("card-actions", CardActionsController)

import CompareTrayController from "./compare_tray_controller"
application.register("compare-tray", CompareTrayController)

import LoginModalController from "./login_modal_controller"
application.register("login-modal", LoginModalController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import CardBookingController from "./card_booking_controller"
application.register("card-booking", CardBookingController)

import CardHospitalController from "./card_hospital_controller"
application.register("card-hospital", CardHospitalController)

import MobileCtaController from "./mobile_cta_controller"
application.register("mobile-cta", MobileCtaController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)
application.register("collapse", AccordionController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import CategoriesToggleController from "./categories_toggle_controller"
application.register("categories-toggle", CategoriesToggleController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import EeatPanelController from "./eeat_panel_controller"
application.register("eeat-panel", EeatPanelController)

